import { api } from '../../../App';

export const uploadFile = async (file: File): Promise<string> => {
  const { data } = await api.upload.apiSubmissionsFilePost(file);

  if (!data.id) {
    throw new Error();
  }

  return data.id;
};
